import { loginRequest } from "authConfig";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";

// Material Dashboard 2 React imports
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Updated background image
import bgImage from "assets/images/homepage.png"; // Ensure this image is placed correctly in your project
import projectLogo from "assets/images/Sharpwatch_Banner_white.png";

function Basic() {
  const { instance: msalInstance, accounts } = useMsal();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  // Set the active account on redirect completion
  useEffect(() => {
    if (accounts && accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }, [accounts, msalInstance]);

  // Redirect to /home if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
  }, [isAuthenticated, navigate]);

  // Use redirect instead of popup
  const handleLogin = () => {
    msalInstance.loginRedirect(loginRequest);
  };

  return (
    <BasicLayout image={bgImage}>
      {/* Main container */}
      <MDBox
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        {/* Logo Container */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "90%", sm: "80%", md: "700px", lg: "800px" }}
          px={2}
          py={2}
          mt={{ xs: -4, sm: -5 }}
          mb={2}
          borderRadius="20px"
          sx={{
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
            background: "rgba(0, 0, 0, 0.15)",
            backdropFilter: "blur(8px)",
          }}
        >
          <img
            src={projectLogo}
            alt="Project Logo"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </MDBox>

        {/* Login Card */}
        <Card
          sx={{
            marginTop: "3rem",
            background: "rgba(0, 0, 0, 0.2)",
            color: "white",
            borderRadius: "16px",
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
            padding: "1rem",
            maxWidth: "400px",
            textAlign: "center",
            backdropFilter: "blur(8px)",
          }}
        >
          <MDBox>
            <MDButton
              variant="contained"
              onClick={handleLogin}
              sx={{
                background: "(90deg,rgb(21, 30, 195),rgba(43, 108, 193, 0))",
                color: "white",
                "&:hover": {
                  boxShadow: "0px 0px 15px rgba(113, 135, 233, 0.6)",
                },
                padding: "12px",
                fontSize: "16px",
                width: "150px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
            >
              SIGN IN
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>
    </BasicLayout>
  );
}

export default Basic;
